import React, { Fragment } from "react";

const PreciosSection = (props) => {
  const {
    tarifaNeta,
    cargosAdministrativos,
    impuestos,
    totalSeguroCancelacion,
    moneda
  } = props;

  return (
    <ul className="info form-row">
      <li className="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-6">Tarifa Neta</li>
      <li className="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-6 precio">
        {moneda} {Math.round(tarifaNeta).toLocaleString()}
      </li>
      <li className="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-6">
        Cargos Administrativos
      </li>
      <li className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 precio">
      {moneda} {cargosAdministrativos.toLocaleString()}
      </li>
      {impuestos && (
        <Fragment>
          <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Impuestos</li>
          <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
          {moneda} {Math.round(impuestos).toLocaleString()}
          </li>
        </Fragment>
      )}
      {totalSeguroCancelacion > 0 && (
        <Fragment>
          <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            Seguro de Cancelaci&oacute;n
          </li>
          <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
          {moneda} {(totalSeguroCancelacion).toLocaleString()}
          </li>
        </Fragment>
      )}
    </ul>
  );
};

export default PreciosSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/preciosSection.js